import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ModalHeader, ModalBody } from 'reactstrap';
import cx from 'classnames';
import _ from 'lodash';

import ResponsiveModal from '../../common/ResponsiveModal';

import { withShowMonitoring } from './enhancers';

import ContainerTreatmentResultRecordsForm from '././TreatmentResultRecordsContainerForm';

import styles from './TreatmentResultRecordsModal.module.scss';

const propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
  currentTreatmentResultRecord: PropTypes.object,
  showMonitoring: PropTypes.bool,
};

class ContainerTreatmentResultRecordsModal extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    // deep equal
    return !_.isEqual(nextProps, this.props);
  }

  render() {
    const {
      title,
      isOpen,
      toggle,
      onSubmit,
      currentTreatmentResultRecord,
      showMonitoring,
      jobType,
    } = this.props;

    return (
      <ResponsiveModal
        size="lg"
        title={title}
        isOpen={isOpen}
        toggle={toggle}
        className={cx({ [styles.largeModal]: showMonitoring })}
      >
        <ModalHeader toggle={toggle}>{title || ''}</ModalHeader>
        <ModalBody className={styles.modalBody}>
          <ContainerTreatmentResultRecordsForm
            currentTreatmentResultRecord={currentTreatmentResultRecord}
            jobType ={jobType}
            onSubmit={onSubmit}
            isCoveredContainer={true}
          />
        </ModalBody>
      </ResponsiveModal>
    );
  }
}

ContainerTreatmentResultRecordsModal.propTypes = propTypes;

export default withShowMonitoring(ContainerTreatmentResultRecordsModal);
